import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/api";

export const getTenantList = async () => {
  const response = await getRequest("/Account/Tenants");
  return response;
};

export const deleteTenant = async (tenantId) => {
  const response = await deleteRequest(
    `/Account/DeleteTenant?tenantId=${tenantId}`,
  );
  return response;
};
export const deleteSite = async (siteId) => {
  const response = await deleteRequest(`/Account/DeleteSite?siteId=${siteId}`);
  return response;
};
export const createTenant = async (teantInfo) => {
  const response = await postRequest(`/Account/AddTenant`, teantInfo);
  return response;
};
export const createSite = async (siteInfo) => {
  const response = await postRequest(`/Account/AddSite`, siteInfo);
  return response;
};
export const updateSite = async (siteInfo) => {
  const response = await putRequest(`/Account/UpdateSite`, siteInfo);
  return response;
};
export const getTenantInfo = async (tenantId) => {
  const response = await getRequest(`/Account/GetTenant?tenantId=${tenantId}`);
  return response;
};
export const getSiteInfo = async (siteId) => {
  const response = await getRequest(`/Account/GetSite?siteId=${siteId}`);
  return response;
};

export const updateExsitingTenant = async (teantInfo) => {
  const response = await putRequest(`/Account/UpdateTenant`, teantInfo);
  return response;
};

/*--- Maps Apis - START --- */

export const getMapFilters = async () => {
  const response = await getRequest("/Map/MapFilters");
  return response;
};
export const getMapData = async (countryId, tenantId, siteId) => {
  let queryParams = `countryCode=${countryId}`;

  if (tenantId) {
    queryParams += `&tenantId=${tenantId}`;
  }

  if (siteId) {
    queryParams += `&siteId=${siteId}`;
  }

  let response = await getRequest(`/Map?${queryParams}`);
  return response;
};

//Added for wosh
export const getReliabilityScore = async (deviceId) => {
  console.log(`Fetching reliabilityscore for device: ${deviceId}`);
  const response = await getRequest(
    `/Map/GetReliabilityScore/?deviceId=${deviceId}`,
  );
  return response;
};

export const getDashboardPanelCards = async (deviceId, startdate, enddate) => {
  const response = await getRequest(
    `/Map/dashboardPanelCards/deviceId/startdate/enddate?deviceId=${deviceId}&startdate=${startdate}&enddate=${enddate}`,
  );
  return response;
};

export const getDashboardPanelCharts = async (
  deviceId,
  startdate,
  enddate,
  water_loss,
  water_price,
  soap_price,
) => {
  const response = await getRequest(
    `/Map/dashboardPanelCharts/deviceId/startdate/enddate/water_loss/water_price/soap_price?deviceId=${deviceId}&startdate=${startdate}&enddate=${enddate}&water_loss=${water_loss}&water_price=${water_price}&soap_price=${soap_price}`,
  );
  return response;
};

/*--- Maps Apis - END --- */

/*--- Tenant Toggle - Start --- */

export const getTenantsData = async () => {
  const response = await getRequest("/Account/toggle");
  return response;
};

/*--- Tenant Toggle - End --- */
